import React from 'react';
import styled from 'styled-components';
import { FieldError, RegisterOptions } from 'react-hook-form';

export type FormErrorType = Extract<keyof RegisterOptions, string> | 'custom' | 'emailSuggestion';

const StyledInput = styled.input<{ showError: boolean; errorType?: FormErrorType }>`
    -webkit-border-radius: 0;
    -webkit-appearance: none;
    display: inline-block;
    width: 100%;
    padding: 16px;
    border: 1px solid ${props => props.theme.colors.charcoal20};
    font-family: 'Brandon Grotesque Regular', ${props => props.theme.fonts.fontBrandonRegular};
    font-size: ${props => props.theme?.loginRegisterForm?.input?.fontSize ?? '1em'};
    line-height: 1.4;
    letter-spacing: 0.0425em;
    color: ${props => props.theme.colors.charcoal100};

    ${props =>
        props.showError &&
        props.errorType !== 'emailSuggestion' &&
        `
            &:not(:focus) {
                border-color: ${props.theme.colors.red60};            
            }
        `}

    &:read-only {
        color: ${props => props.theme.colors.charcoal40};
    }
`;

const ErrorText = styled.span<{ errorType?: FormErrorType }>`
    font-size: 0.75em;
    line-height: 1;
    ${props =>
        props.errorType !== 'emailSuggestion' &&
        `
            color: ${props.theme.colors.red80};  
        `}
`;

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    showError: boolean;
    errorMsg?: Pick<FieldError, 'message'>;
    errorType?: FormErrorType;
}

const Input = React.forwardRef<HTMLInputElement, Props>(({ showError, errorMsg, errorType, ...props }, ref) => (
    <>
        <StyledInput ref={ref} showError={showError} errorType={errorType} {...props} />
        {showError && (
            <ErrorText className="qa-login-signup-form__input-error" errorType={errorType}>
                {errorMsg}
            </ErrorText>
        )}
    </>
));

export default Input;
